module.exports = __webpack_public_path__ + "media/images/icon__close--rb-white-c1e7bede3f3265c536567c50f82b399b.png";